module.exports = __webpack_public_path__ + "static/media/bg_in_late.6f0a20ae.svg";